import common from "../common";
import GelScene from "../ui/gel/GelScene";
import QuestionInputSelect from "../ui/input/QuestionInputSelect";
import QuestionModuleMeasurement from "../maths/modules/QuestionModuleMeasurement";
import QuestionInputSelectMultiSum from "../ui/input/QuestionInputSelectMultiSum";
import QuestionInputSelectSum from "../ui/input/QuestionInputSelectSum";
import QuestionViewVisualLiquid from "../ui/view/QuestionViewVisualLiquid";
import QuestionViewVerbalConversion from "../ui/view/QuestionViewVerbalConversion";
import QuestionViewVerbalTime from "../ui/view/QuestionViewVerbalTime";
import QuestionViewVisualTime from "../ui/view/QuestionViewVisualTime";
import QuestionViewVerbalClockFace from "../ui/view/QuestionViewVerbalClockFace";
import QuestionInputSelectClockFace from "../ui/input/QuestionInputSelectClockFace";
import QuestionViewVerbalShape from "../ui/view/QuestionViewVerbalShape";
import QuestionInput from "../ui/input/QuestionInput";
import QuestionInputSelectMulti from "../ui/input/QuestionInputSelectMulti";
import QuestionInputSelectVisual from "../ui/input/QuestionInputSelectVisual";
import QuestionInputKeypad from "../ui/input/QuestionInputKeypad";
import QuestionInputSort from "../ui/input/QuestionInputSort";
import QuestionView from "../ui/view/QuestionView";
import QuestionViewStatement from "../ui/view/QuestionViewStatement";
import QuestionViewStatementMulti from "../ui/view/QuestionViewStatementMulti";
import QuestionViewStatementLong from "../ui/view/QuestionViewStatementLong";
import QuestionViewStatementFraction from "../ui/view/QuestionViewStatementFraction";
import QuestionViewStatementAlgebra from "../ui/view/QuestionViewStatementAlgebra";
import QuestionViewStatementAlgebraPair from "../ui/view/QuestionViewStatementAlgebraPair";
import QuestionViewVerbal from "../ui/view/QuestionViewVerbal";
import QuestionViewBoolean from "../ui/view/QuestionViewBoolean";
import QuestionViewVerbalExponent from "../ui/view/QuestionViewVerbalExponent";
import QuestionViewVerbalRound from "../ui/view/QuestionViewVerbalRound";
import QuestionViewSort from "../ui/view/QuestionViewSort";
import QuestionViewVisual from "../ui/view/QuestionViewVisual";
import QuestionViewComparison from "../ui/view/QuestionViewComparison";
import QuestionViewSequence from "../ui/view/QuestionViewSequence";
import QuestionViewVerbalEquivalent from "../ui/view/QuestionViewVerbalEquivalent";
import QuestionViewVerbalRatio from "../ui/view/QuestionViewVerbalRatio";
import QuestionViewVerbalValue from "../ui/view/QuestionViewVerbalValue";
import QuestionViewVerbalCompose from "../ui/view/QuestionViewVerbalCompose";
import QuestionViewVerbalMultiples from "../ui/view/QuestionViewVerbalMultiples";
import QuestionViewVerbalFindRest from "../ui/view/QuestionViewVerbalFindRest";
import QuestionViewGraphVen from "../ui/view/QuestionViewGraphVen";
import QuestionViewGraphBar from "../ui/view/QuestionViewGraphBar";
import QuestionViewGraphTally from "../ui/view/QuestionViewGraphTally";
import QuestionInputSelectMultiEquivalents from "../ui/input/QuestionInputSelectMultiEquivalents";
import QuestionModuleShapes from "../maths/modules/QuestionModuleShapes";
import QuestionViewVisualEquivalent from "../ui/view/QuestionViewVisualEquivalent";
import QuestionInputSelectMultiVisualEquivalents from "../ui/input/QuestionInputSelectMultiVisualEquivalents";
import QuestionInputSelectTime from "../ui/input/QuestionInputSelectTime";
import QuestionInputSelectMultiGraph from "../ui/input/QuestionInputMultiGraph";
import QuestionViewVerbalSum from "../ui/view/QuestionViewVerbalSum";
import QuestionModule from "../maths/modules/QuestionModule";
import QuestionModuleArithmetic from "../maths/modules/QuestionModuleArithmetic";
import QuestionModuleAlgebra from "../maths/modules/QuestionModuleAlgebra";
import QuestionModulePlaceValue from "../maths/modules/QuestionModulePlaceValue";
import QuestionModuleVisual from "../maths/modules/QuestionModuleVisual";
import QuestionModuleFractionArithmetic from "../maths/modules/QuestionModuleFractionArithmetic";
import QuestionModuleArithmeticRoman from "../maths/modules/QuestionModuleArithmeticRoman";
import QuestionModuleSorting from "../maths/modules/QuestionModuleSorting";
import QuestionModuleBoolean from "../maths/modules/QuestionModuleBoolean";
import QuestionModuleSequence from "../maths/modules/QuestionModuleSequence";
import QuestionModuleExponent from "../maths/modules/QuestionModuleExponent";
import QuestionModuleRatio from "../maths/modules/QuestionModuleRatio";
import QuestionModuleStats from "../maths/modules/QuestionModuleStats";
import QuestionModuleMultiples from "../maths/modules/QuestionModuleMultiples";
import QuestionModuleSum from "../maths/modules/QuestionModuleSum";
import QuestionModel from "../maths/QuestionModel";
import QuestionInputSortConversion from "../ui/input/QuestionInputSortConversion";
import QuestionViewVerbalVolume from "../ui/view/QuestionViewVerbalVolume";
import QuestionViewVerbalStats from "../ui/view/QuestionViewVerbalStats";
import QuestionViewVerbalAngle from "../ui/view/QuestionViewVerbalAngle";
import QuestionViewRotatedShape from "../ui/view/QuestionViewRotatedShape";
import QuestionInputSelectMultiVisual from "../ui/input/QuestionInputSelectMultiVisual";
import QuestionViewVerbalStatic from "../ui/view/QuestionViewVerbalStatic";
import QuestionModuleStatic from "../maths/modules/QuestionModuleStatic";
import QuestionViewVisualShape from "../ui/view/QuestionViewVisualShape";

export default class QuestionScene extends GelScene {
    constructor() {
        super();
    }

    init() {
        super.init();
        this.reset();

        common.gui.signals.submit.add(()=>this.reset());
    }

    reset(){

        if(this._questionView){
            this.removeChild(this._questionView);
            this._questionView = null;
            this.removeChild(this._questionInput);
            this._questionInput = null;
        }

        var module = common.gui.module || 'measurement';// url.searchParams.get("module");
        var questionType = common.gui.question || 'area_triangle';// url.searchParams.get("question");
        var difficulty = common.gui.difficulty || 2;//url.searchParams.get("difficulty");

        let data = [];
        let questions = P3.assets.json("questions");
        const staticQuestions = P3.assets.json('static_questions');
        questions.static = staticQuestions.static;

        for (const i in questions) {
            if (questions.hasOwnProperty(i)) {
                if(i === module){
                    const t = P3.utils.objectToArray(questions[i].filter(x =>{
                        return x.enabled && x.difficulty === Number(difficulty) && x.type === questionType
                    }));
                    for (let j = 0; j < t.length; ++j) t[j].module = i;  // we add 'module' as a property
                    data = data.concat(t);
                }
            }
        }

        const t = P3.utils.selectRandom(data);

        const question = this.model(t);
        this.view(question);
        this.input(question);

        console.log(question);
    }

    model(t){
        switch (t.module) {
            case 'static':{
                return new QuestionModuleStatic().create(t);
            }
            case QuestionModule.MODULE_ARITHMETIC : {
                return new QuestionModuleArithmetic().create(t);
            }
            case QuestionModule.MODULE_ALGEBRA : {
                return new QuestionModuleAlgebra().create(t);
            }
            case QuestionModule.MODULE_PLACE_VALUE : {
                return new QuestionModulePlaceValue().create(t);
            }
            case QuestionModule.MODULE_VISUAL : {
                return new QuestionModuleVisual().create(t);
            }
            case QuestionModule.MODULE_FRACTION_ARITHMETIC : {
                return new QuestionModuleFractionArithmetic().create(t);
            }
            case QuestionModule.MODULE_ROMAN_ARITHMETIC : {
                return new QuestionModuleArithmeticRoman().create(t);
            }
            case QuestionModule.MODULE_SORTING : {
                return new QuestionModuleSorting().create(t);
            }
            case QuestionModule.MODULE_BOOLEAN : {
                return new QuestionModuleBoolean().create(t);
            }
            case QuestionModule.MODULE_SHAPES : {
                return new QuestionModuleShapes().create(t);
            }
            case QuestionModule.MODULE_SEQUENCE : {
                return new QuestionModuleSequence().create(t);
            }
            case QuestionModule.MODULE_EXPONENT : {
                return new QuestionModuleExponent().create(t);
            }
            case QuestionModule.MODULE_MEASUREMENT : {
                return new QuestionModuleMeasurement().create(t);
            }
            case QuestionModule.MODULE_RATIO : {
                return new QuestionModuleRatio().create(t);
            }
            case QuestionModule.MODULE_STATS : {
                return new QuestionModuleStats().create(t);
            }
            case QuestionModule.MODULE_MULTIPLES : {
                return new QuestionModuleMultiples().create(t);
            }
            case QuestionModule.MODULE_SUM : {
                return new QuestionModuleSum().create(t);
            }
        }
        return new QuestionModel(t.type, t.view, t.input);
    }

    view(question){
        switch (question.view) {
            default                                         : console.warn("unknown question view : " + question.view); break;
            case QuestionView.STATIC_VERBAL                 : {this._questionView = new QuestionViewVerbalStatic(question);         break;}
            case QuestionView.VIEW_STATEMENT                : {this._questionView = new QuestionViewStatement(question);            break;}
            case QuestionView.VIEW_STATEMENT_MULTI          : {this._questionView = new QuestionViewStatementMulti(question);       break;}
            case QuestionView.VIEW_STATEMENT_LONG           : {this._questionView = new QuestionViewStatementLong(question);        break;}
            case QuestionView.VIEW_STATEMENT_FRACTION       : {this._questionView = new QuestionViewStatementFraction(question);    break;}
            case QuestionView.VIEW_STATEMENT_ALGEBRA        : {this._questionView = new QuestionViewStatementAlgebra(question);     break;}
            case QuestionView.VIEW_STATEMENT_ALGEBRA_PAIR   : {this._questionView = new QuestionViewStatementAlgebraPair(question); break;}
            case QuestionView.VIEW_VERBAL                   : {this._questionView = new QuestionViewVerbal(question);               break;}
            case QuestionView.VIEW_VERBAL_VOLUME            : {this._questionView = new QuestionViewVerbalVolume(question);         break;}
            case QuestionView.VIEW_VERBAL_BOOLEAN           : {this._questionView = new QuestionViewBoolean(question);              break;}
            case QuestionView.VIEW_VERBAL_EXPONENT          : {this._questionView = new QuestionViewVerbalExponent(question);       break;}
            case QuestionView.VIEW_VERBAL_ROUND             : {this._questionView = new QuestionViewVerbalRound(question);          break;}
            case QuestionView.VIEW_VERBAL_STATS             : {this._questionView = new QuestionViewVerbalStats(question) ;         break;}
            case QuestionView.VIEW_SORT                     : {this._questionView = new QuestionViewSort(question);                 break;}
            case QuestionView.VIEW_VISUAL                   : {this._questionView = new QuestionViewVisual(question);               break;}
            case QuestionView.VIEW_VISUAL_TIME              : {this._questionView = new QuestionViewVisualTime(question);           break;}
            case QuestionView.VIEW_VISUAL_CLOCK_FACE        : {this._questionView = new QuestionViewVerbalClockFace(question);      break;}
            case QuestionView.VIEW_VISUAL_LIQUID            : {this._questionView = new QuestionViewVisualLiquid(question);         break;}
            case QuestionView.VIEW_VISUAL_ROTATED_SHAPE     : {this._questionView = new QuestionViewRotatedShape(question);         break;}
            case QuestionView.VIEW_COMPARISON               : {this._questionView = new QuestionViewComparison(question);           break;}
            case QuestionView.VIEW_SEQUENCE                 : {this._questionView = new QuestionViewSequence(question);             break;}
            case QuestionView.VIEW_VERBAL_SHAPE             : {this._questionView = new QuestionViewVerbalShape(question);          break;}
            case QuestionView.VIEW_VERBAL_EQUIVALENT        : {this._questionView = new QuestionViewVerbalEquivalent(question);     break;}
            case QuestionView.VIEW_VERBAL_RATIO             : {this._questionView = new QuestionViewVerbalRatio(question);          break;}
            case QuestionView.VIEW_VERBAL_VALUE             : {this._questionView = new QuestionViewVerbalValue(question);          break;}
            case QuestionView.VIEW_VERBAL_COMPOSE           : {this._questionView = new QuestionViewVerbalCompose(question);        break;}
            case QuestionView.VIEW_VERBAL_MULTIPLES         : {this._questionView = new QuestionViewVerbalMultiples(question);      break;}
            case QuestionView.VIEW_VERBAL_TIME              : {this._questionView = new QuestionViewVerbalTime(question);           break;}
            case QuestionView.VIEW_VERBAL_CONVERSION        : {this._questionView = new QuestionViewVerbalConversion(question);     break;}
            case QuestionView.VIEW_VERBAL_REST              : {this._questionView = new QuestionViewVerbalFindRest(question);       break;}
            case QuestionView.VIEW_VERBAL_SUM               : {this._questionView = new QuestionViewVerbalSum(question);            break;}
            case QuestionView.VIEW_VERBAL_ANGLE             : {this._questionView = new QuestionViewVerbalAngle(question);          break;}
            case QuestionView.VIEW_GRAPH_VEN                : {this._questionView = new QuestionViewGraphVen(question);             break;}
            case QuestionView.VIEW_GRAPH_BAR                : {this._questionView = new QuestionViewGraphBar(question);             break;}
            case QuestionView.VIEW_GRAPH_TALLY              : {this._questionView = new QuestionViewGraphTally(question);           break;}
            case QuestionView.VIEW_VISUAL_EQUIVALENT        : {this._questionView = new QuestionViewVisualEquivalent(question);     break;}
            case QuestionView.VIEW_VISUAL_SHAPE             : {this._questionView = new QuestionViewVisualShape(question);         break;}
        }
        this._questionView.position.set(common.STAGE_WIDTH * 0.5, 0);
        this._questionView.signals.confirm.add(() => {
            console.error("IS CORRECT : " + this._questionView.isCorrect());
            this.reset();
        }, this);
        this.addChild(this._questionView);

        this._questionView.header.y = this._questionView.header.height * 0.5 + 20;
        this._questionView.footer.y = P3.View.height - this._questionView.footer.height * 0.5 - 60;
    }

    input(question){
        if(Array.isArray(question.input)){
            question._input = P3.utils.selectRandom(question.input)
        }
        switch (question.input) {
            default :
            case QuestionInput.INPUT_SELECT : {
                this._questionInput = new QuestionInputSelect(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footer.height * 0.5 - 40);
                break;
            }
            case QuestionInput.INPUT_SELECT_SUM : {
                this._questionInput = new QuestionInputSelectSum(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footer.height * 0.5 - 40);
                break;
            }
            case QuestionInput.INPUT_SELECT_TIME : {
                this._questionInput = new QuestionInputSelectTime(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footer.height * 0.5 - 40);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI : {
                this._questionInput = new QuestionInputSelectMulti(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_SUM : {
                this._questionInput = new QuestionInputSelectMultiSum(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_VISUAL : {
                this._questionInput = new QuestionInputSelectMultiVisual(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_EQUIVALENT : {
                this._questionInput = new QuestionInputSelectMultiEquivalents(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y - 100);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_GRAPH : {
                this._questionInput = new QuestionInputSelectMultiGraph(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y - 100);
                break;
            }
            case QuestionInput.INPUT_SELECT_VISUAL : {
                this._questionInput = new QuestionInputSelectVisual(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_CLOCK_FACE : {
                this._questionInput = new QuestionInputSelectClockFace(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_KEYPAD : {
                this._questionInput = new QuestionInputKeypad(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footer.height * 0.5 - 20);
                break;
            }
            case QuestionInput.INPUT_KEYPAD_RIGHT : {
                this._questionInput = new QuestionInputKeypad(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5 + 250,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footer.height * 0.5 - 20);
                break;
            }
            case QuestionInput.INPUT_SORT : {
                this._questionInput = new QuestionInputSort(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SORT_CONVERSION : {
                this._questionInput = new QuestionInputSortConversion(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_VISUAL_EQUIVALENT : {
                this._questionInput = new QuestionInputSelectMultiVisualEquivalents(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y - 100);
                break;
            }
        }
        this._questionInput.init();
        this.addChild(this._questionInput);
    }

    resize() {
        super.resize();

        this.hitArea = new PIXI.Rectangle(
            (common.STAGE_WIDTH - P3.View.width) * 0.5,
            0,
            P3.View.width,
            P3.View.height
        );
    }

    update() {
        const dt = window.dt;
        this._questionInput.update(dt);
    }
}